var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-route-details"},[_vm._m(0),_c('o-route-step',{attrs:{"type":"walk","trajectory":{
      label: 'Wandel naar Gent Zonnestraat.',
      duration: '1 min.'
    }}}),_c('o-route-step',{attrs:{"type":"tram","start":"Gent Zonnestraat","end":"Gent-Sint-Pietersstation","trajectory":{
      number: '1',
      color: '#C23A00',
      label: 'Gent-Sint-Pietersstation',
      sublabel: '15:44 - halte 200025',
      duration: '17 min.'
    }}}),_c('o-route-step',{attrs:{"type":"train","start":"Station Gent-Sint-Pieters","end":"Station Antwerpen-Centraal","trajectory":{
      number: 'IC',
      color: '#006FAC',
      label: 'Sint-Niklaas - Antwerpen',
      sublabel: '16:10 - spoor 6',
      duration: '45 min.'
    }}}),_c('o-route-step',{attrs:{"type":"bus","start":"Antwerpen Astrid","end":"Melkmarkt","trajectory":{
      number: '10',
      color: '#789600',
      label: 'Melkmarkt',
      sublabel: '17:00 - halte 200021',
      duration: '13 min.'
    }}}),_c('o-route-step',{attrs:{"type":"walk","trajectory":{
      label: 'Wandel naar Eiermarkt.',
      duration: '1 min.'
    }}}),_vm._m(1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-route-details__start"},[_c('div',{staticClass:"c-route-details__start-time"},[_vm._v("15:39")]),_c('div',[_vm._v("Ajuinlei 1, Gent")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-route-details__end"},[_c('div',{staticClass:"c-route-details__end-time"},[_vm._v("17:16")]),_c('div',[_vm._v("Eiermarkt, Antwerpen")])])}]

export { render, staticRenderFns }